<script setup>
import {ref, nextTick, onMounted} from "vue";
import ElasticChat from "@/views/newSearch/ElasticChat.vue";
import elasticAiConversationsService from "@/services/elastic-ai-conversations.service";

const chatStarted = ref(false);
const question = ref("");
const chat = ref(null);
const historyOpened = ref(false);
const recentConversations = ref([]);

onMounted(() => {
    getRecentConversations();
});

async function sendRequest() {
    if (!question.value.trim()) {
        return;
    }

    chatStarted.value = true;
    await nextTick();

    chat.value.startChat(question.value);
}

async function openConversation(conversationId) {
    chatStarted.value = true;
    await nextTick();

    chat.value.openConversation(conversationId);
    historyOpened.value = false;
}

function resetChat() {
    chatStarted.value = false;
    question.value = '';
}

async function getRecentConversations() {
    const {data} = await elasticAiConversationsService.getRecentConversations();
    recentConversations.value = data;
}
</script>

<template>
    <section class="section-ai-chat">
        <div class="ai-chat__inner">
            <b-tabs class="ai-chat__tabs">
                <b-tab title="Discovery" title-link-class="tabs-discovery">
                    <template v-if="!chatStarted">
                        <div class="ai-chat__tabs__inner">
                            <h5 class="heading5 heading5--secondary">Describe the startups you’re looking for.</h5>

                            <div class="card--ai__search">
                                <input
                                    v-focus
                                    v-model="question"
                                    placeholder="Search over 480,000 startups"
                                    class="card--ai__search__input"
                                    @keyup.enter="sendRequest"
                                >

                                <button class="card--ai__search__button" @click="sendRequest"/>
                            </div>

                            <div v-if="recentConversations.length">
                                <h6 class="heading6">Recent</h6>

                                <ul class="list-recent">
                                    <li v-for="conversation in recentConversations.slice(0, 5)" :key="conversation.id">
                                        <a @click="openConversation(conversation.id)">{{ conversation.title }}</a>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <template v-if="false">
                            <h6 class="heading6">Here are startups that match your parameters:</h6>

                            <header class="ai-chat__results-header">
                                <div class="show-ai-select-box">
                                    <select>
                                        <option>Showing 5 results</option>
                                        <option>Showing 10 results</option>
                                        <option>Showing 15 results</option>
                                    </select>
                                </div>

                                <p>Filter results in <a href="#" class="link-to-tab">Manual Mode</a></p>
                            </header>
                        </template>
                    </template>
                </b-tab>

                <b-tab title="Manual Mode" title-link-class="tabs-manual">
                    <h5 class="heading5 heading5--secondary">Decsribe</h5>
                </b-tab>

                <b-tab title="Search By Name" title-link-class="tabs-search">
                    <h5 class="heading5 heading5--secondary">Search</h5>
                </b-tab>

                <b-tab title="Ecosystems" title-link-class="tabs-ecosystems">
                    <h5 class="heading5 heading5--secondary">Ecosystems</h5>
                </b-tab>
            </b-tabs>

            <div v-if="chatStarted" class="section-ai-chat__controls">
                <div v-if="!historyOpened" class="section-ai-chat__controls__nav">
                    <a @click="resetChat" class="section-ai-chat__controls__nav__compose"></a>
                    <b-button
                        v-if="recentConversations.length"
                        class="section-ai-chat__controls__nav__history"
                        @click="historyOpened = !historyOpened"
                    ></b-button>
                </div>

                <b-collapse id="collapse-1" v-model="historyOpened">
                    <div class="section-ai-chat__plate">
                        <header class="section-ai-chat__plate__header">
                            <h5 class="heading5 heading5--secondary">Chat History</h5>

                            <b-button class="close" variant="danger" @click="historyOpened = !historyOpened"></b-button>
                        </header>

                        <ul class="section-ai-chat__plate__list">
                            <li v-for="conversation in recentConversations" :key="conversation.id">
                                <a @click="openConversation(conversation.id)">{{ conversation.title }}</a>
                            </li>
                        </ul>
                    </div>
                </b-collapse>
            </div>

            <ElasticChat
                v-if="chatStarted"
                ref="chat"
                @reset="resetChat"
            />
        </div>
    </section>
</template>

<style scoped>

</style>
